'use strict';

var Sugar = require('sugar-core'),
    getDaysInMonth = require('./internal/getDaysInMonth');

Sugar.Date.defineInstance({

  'daysInMonth': function(date) {
    return getDaysInMonth(date);
  }

});

module.exports = Sugar.Date.daysInMonth;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/date/daysInMonth.js
// module id = 174
// module chunks = 1